import { Element, useNode } from "@craftjs/core";
import * as React from "react";
import { Actions } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import {
  NavigationMenu,
  StandaloneNavigationSettings,
} from "@/components/editor/shared/navigation";

import { CTAButtonWrapper, Wrapper } from "./standalone-navigation-styles";

export type StandaloneNavigationProps = {
  isSticky?: boolean;
  showCta?: boolean;
  children: React.ReactNode;
};

export default function StandaloneNavigation(props: StandaloneNavigationProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <Wrapper
      ref={connect}
      id={nodeId}
      className={props.isSticky ? "block-sticky" : undefined}
    >
      <NavigationMenu
        cta={
          props.showCta && (
            <CTAButtonWrapper>
              <Element
                id="cta-button"
                is={Button}
                text="Register"
                action={{ kind: Actions.TicketSelector }}
              />
            </CTAButtonWrapper>
          )
        }
        isCentered={!props.showCta}
        menu={props.children}
      />
    </Wrapper>
  );
}

StandaloneNavigation.craft = {
  isCanvas: true,
  custom: {
    displayName: "Standalone navigation",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: StandaloneNavigationSettings,
  },
};
